<template>
  <!-- 类别 -->
  <div class="classification">
    <div class="classification-page">
      <div>
        <div
          v-for="(item,index) in other"
          :key="index"
          :class="[isActive==index?'active_class':'' ]"
          @click="classinfo(index)"
        >{{item.title}}</div>
      </div>
    </div>
    <div v-show="show" style="margin:auto auto">
      <Calligraphy v-if="hardReset" :tabNumber="this.$store.state.number"></Calligraphy>
    </div>
  </div>
</template>


<script>
// 类别详情
import Calligraphy from "../calligraphy/calligraphy";
import Bus from "../../bus/bus";
export default {
  name: "Classification",
  components: {
    Calligraphy
  },
  data() {
    return {
      // 类别信息
      other: [
        {
          type: "windowtype",
          title: "窗型"
        },
        {
          type: "colour",
          title: "色彩"
        },
        {
          type: "scenery",
          title: "背景"
        }
      ],
      isActive: -1,
      hardReset: true,
      show: false
    };
  },
  mounted() {},
  methods: {
    classinfo(item) {
      this.isActive = item;
      this.$store.commit("classType", item);
      Bus.$emit("tabNumber", 1000);
      this.show = true;
      this.hardReset = false;
      this.$nextTick(() => {
        this.hardReset = true;
      });
    }
  }
};
</script>

<style >
.classification {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}
.classification-page {
  width: 12%;
  height: 100%;
  position: relative;
  z-index: 3;
}
.classification-page > div{
    height: 100%;
}
.classification-page > div div {
  width: 100%;
  background: #000;
  text-align: center;
  opacity: 0.8;
  font-size: 22px;
  padding: 105% 30%;
  color: aliceblue;
  border: 1px solid #585758;
  border-radius: 0 20px 20px 0;
}
.classification > div div .active_class {
  width: 100%;
  background: #333;
  font-size: 22px;
  padding: 105% 40%;
  text-align: center;
  color: #fff;
  border: 1px solid #585758;
  border-radius: 0 20px 20px 0;
}
</style>